
import {useAppSelector} from "../../store";

export function useCurrentAppointmentOpened(): string | null {
    const id = useAppSelector((s) => s.detailAppointment.currentAppointment);

    return (id != null) ? id : null;
}
